import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { useAjaxContext } from '../../../../core/ajax'
import { useManualCombo } from '../../../../features/combos'
import { FilterBox } from '../../../../ui'
import { LEAVES_FILTERS } from '../../constants'
import { Box } from '@mui/material'
import { ExportLeavesToXLSBtn } from '../export-leaves'

export const AdministrativeLeavesFilter = () => {
  const { formatMessage } = useIntl()
  const { get } = useAjaxContext()
  const { setManualCombo } = useManualCombo()
  const [provinceOptions, setProvinceOptions] = useState([])

  // Fetch all records once to extract unique province values
  useEffect(() => {
    get('bajas_administrativas/', { params: { _num_x_pagina: 0 } })
      .then(({ data }) => {
        if (data?.items) {
          const unique = [
            ...new Set(data.items.map((item) => item.provincia).filter(Boolean)),
          ].sort()
          const options = unique.map((name) => ({ key: name, value: name }))
          setProvinceOptions(options)
          setManualCombo('bajas_administrativas_provincias', options)
        }
      })
      .catch((err) => {
        console.error('Error cargando provincias dinámicas', err)
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const filters = LEAVES_FILTERS.map((item) => {
    const result = { ...item }
    if (item.comboId === 'bajas_administrativas_provincias') {
      result.values = provinceOptions
    }
    return {
      ...result,
      label: formatMessage({
        id: 'pages.administrativeLeaves.filters.' + item.name + '.title',
      }),
    }
  })

  const buttonsComponent = (
    <Box display="flex" flexGrow={0.5} justifyContent="flex-end">
      <ExportLeavesToXLSBtn />
    </Box>
  )

  return <FilterBox filters={filters}>{buttonsComponent}</FilterBox>
}
